export const DOMAINS = {
  TRISOLUTION: 'trisolution.com.br',
  // MD_TRIBUTARIA: 'mdtributaria.com.br',
  // GRUPO_BAHIA_SUL: 'grupobahiasul.com.br',
  DS_CONSULTORIA: 'dsconsultoriat.com.br',
  KLINGER: 'klingerconsults.com.br',
  DEFAULT: 'default'
}

const domainConfigs = {
  default: {
    title: 'Klinger',
    icon: '/50734366000162.svg',
    iconPNG: '/50734366000162.png',
    iconBG: '/bl-50734366000162.svg',
    theme: {
      '--primary-color': '#0D0D0D',
      '--primary-hover': '#424242',
      '--text-color': '#F2F2F2'
    },
    themeColor: '#0D0D0D',
    backgroundColor: '#ffffff',
    domainPath: 'https://web.klingerconsults.com.br' || `https://www.klingerconsults.com.br`,
    id: '50734366000162'
  },
  [DOMAINS.KLINGER]: {
    title: 'Klinger',
    icon: '/50734366000162.svg',
    iconPNG: '/50734366000162.png',
    iconBG: '/bl-50734366000162.svg',
    theme: {
      '--primary-color': '#0D0D0D',
      '--primary-hover': '#424242',
      '--text-color': '#F2F2F2'
    },
    themeColor: '#0D0D0D',
    backgroundColor: '#ffffff',
    domainPath: 'https://web.klingerconsults.com.br' || `https://www.klingerconsults.com.br`,
    id: '50734366000162'
  },
  [DOMAINS.TRISOLUTION]: {
    title: 'Trisolution',
    icon: '/48762505000110.svg',
    iconPNG: '/48762505000110.png',
    iconBG: '/bl-48762505000110.svg',
    theme: {
      '--primary-color': '#12142D',
      '--primary-hover': '#0F3984',
      '--text-color': '#F1FFE8'
    },
    themeColor: '#12142D',
    backgroundColor: '#ffffff',
    domainPath: 'https://web.trisolution.com.br',
    id: '48762505000110'
  },
  // [DOMAINS.MD_TRIBUTARIA]: {
  //   title: 'MD Tributaria',
  //   icon: '/46553339000116.svg',
  //   iconPNG: '/46553339000116.png',
  //   iconBG: '/bl-46553339000116.svg',
  //   theme: {
  //     '--primary-color': '#0A3838',
  //     '--primary-hover': '#1D5959',
  //     '--text-color': '#A5A5A4'
  //   },
  //   themeColor: '#0A3838',
  //   backgroundColor: '#ffffff',
  //   domainPath: 'https://web.mdtributaria.com.br' || `https://www.mdtributaria.com.br`,
  //   id: '46553339000116'
  // },
  // [DOMAINS.GRUPO_BAHIA_SUL]: {
  //   title: 'Bahia Sul',
  //   icon: '/46151037000111.svg',
  //   iconPNG: '/46151037000111.png',
  //   iconBG: '/bl-46151037000111.svg',
  //   theme: {
  //     '--primary-color': '#122724',
  //     '--primary-hover': '#3A5753',
  //     '--text-color': '#BFAB50'
  //   },
  //   themeColor: '#122724',
  //   backgroundColor: '#ffffff',
  //   domainPath: 'https://web.grupobahiasul.com.br' || `https://www.grupobahiasul.com.br`,
  //   id: '46151037000111'
  // },
  [DOMAINS.DS_CONSULTORIA]: {
    title: 'DS Consultoria',
    icon: '/59754843000126.svg',
    iconPNG: '/59754843000126.png',
    iconBG: '/bl-59754843000126.svg',
    theme: {
      '--primary-color': '#3a3850',
      '--primary-hover': '#90949f',
      '--text-color': '#f7c13a'
    },
    themeColor: '#3a3850',
    backgroundColor: '#f7c13a',
    domainPath: 'https://web.dsconsultoriat.com.br',
    id: '59754843000126'
  }
}

export default domainConfigs
